export interface Testimonial {
  id: number;
  name: string;
  content: string;
  image?: string;
  profileUrl?: string;
  highlights?: string[];
  rating: number;
}

export const wallOfLove: Testimonial[] = [
  {
    id: 24,
    name: "Skolte",
    content: "Well i really like #whisprflow but i found this new Speech to Text gem that runs locally on my mac and works like a breeze. @tryvoiceink for now not looking back and using this one as my daily driver STT solution.",
    image: "https://pbs.twimg.com/profile_images/1922150970928013312/fXOWa5r8_400x400.jpg",
    highlights: ["runs locally on my mac and works like a breeze", "my daily driver STT solution"],
    rating: 5
  },
  {
    id: 25,
    name: "Kani",
    content: "After trying out multiple dictation apps, have landed on the best. Voiceink is really good for mac with sleek interface and the cheapest with just 1 time payment. @JoshiPax",
    image: "https://pbs.twimg.com/profile_images/1903742670209699840/NueNdVuP_400x400.jpg",
    highlights: ["landed on the best", "cheapest with just 1 time payment"],
    rating: 5
  },
  {
    id: 26,
    name: "Will Bunting",
    content: "Switched from Superwhisper to VoiceInk for voice transcription. Superwhisper couldn't interface properly with my thunderbolt audio setup. VoiceInk handles audio interfaces flawlessly (and as a bonus spaces transcriptions better)",
    image: "https://pbs.twimg.com/profile_images/1946810432674787328/mca5kN65_400x400.jpg",
    highlights: ["Switched from Superwhisper to VoiceInk"],
    rating: 5
  },
  {
    id: 27,
    name: "pseudonymoss",
    content: "VoiceInk is data sovereign and one time fee. Switched from superwhisper never looked back",
    highlights: ["Switched from superwhisper never looked back"],
    rating: 5
  },
  {
    id: 28,
    name: "George Collier",
    content: "voiceink by @JoshiPax I recommend, it's an indie dev, local models so works offline, no subscription bullshit. Cheap one time purchase. Give the guy his money.",
    highlights: ["Give the guy his money."],
    rating: 5
  },
  {
    id: 29,
    name: "Bhavya",
    content: "If someone is looking for alternative for mac. You can use @tryvoiceink. It's open source and you can use local model also. Even with a small 150mb model it's soo accurate and UX is also great.",
    highlights: ["soo accurate and UX is also great"],
    rating: 5
  },
  {
    id: 30,
    name: "Gorka Cesium",
    content: "@tryvoiceink offers great value for its cost. It runs locally, supports multiple languages, allowing switches between Spanish, English, and others, and requires one low lifetime payment. It's a good deal with a powerful computer.",
    image: "https://pbs.twimg.com/profile_images/1677734830040051714/Nhy4YdBZ_400x400.jpg",
    highlights: ["great value for its cost", "one low lifetime payment"],
    rating: 5
  },
  {
    id: 31,
    name: "Nir Shney-dor 🎗️",
    content: "I gotta say that paying for @tryvoiceink was an easy decision, it's really good!",
    image: "https://pbs.twimg.com/profile_images/1685594521/nir_avatar_400x400.png",
    highlights: ["paying for @tryvoiceink was an easy decision, it's really good!"],
    rating: 5
  },
  {
    id: 32,
    name: "Pranjal Paliwal",
    content: "I was sold on WisprFlow when I ran out of free limits on that and bumped on the @tryvoiceink and damn it is good! and that too OFFLINE !!!!! officially part of the vibe stack with cursor and claude code.",
    image: "https://pbs.twimg.com/profile_images/1904971809067352064/XWy8QZcv_400x400.jpg",
    highlights: ["damn it is good!", "and that too OFFLINE !!!!!"],
    rating: 5
  },
  {
    id: 15,
    name: "Joachim M. Guentert",
    content: "Hi Joshi, we just spent 200 USD on WisprFlow yearly (!) BEFORE I tested VoiceInk. My fault. Now, we have bought 3 VoiceInk licenses. Keep up the great work. It's a strong productivity booster and we love it!",
    image: "/testimonials/Joachim.jpg",
    highlights: ["we just spent 200 USD on WisprFlow yearly", "Now, we have bought 3 VoiceInk licenses"],
    rating: 5
  },
  {
    id: 14,
    name: "O. o",
    content: "I bought this software a long time ago, and it was reasonably priced. The early versions were already quite feature-rich, and the author actively listens to user feedback on Discord and updates the product quickly. Several of my suggestions have been implemented, so I'm really happy to see an app gradually meeting more users' needs. Recently, the author even open-sourced the application, which means you can review its code to avoid any potential privacy risks. You can also build a local version yourself for free if you want. Of course, I still recommend buying it to support this lovely developer!",
    image: "/testimonials/o.png",
    highlights: ["I'm really happy to see an app gradually meeting more users' needs"],
    rating: 5
  },
  {
    id: 13,
    name: "Korey",
    content: "I love this app. I use it all the time. I had SuperWhisper, but the cost was too much. The one time payment for Voiceink was perfect. Very Affordable.",
    image: "/testimonials/korey.png",
    highlights: ["I had SuperWhisper, but the cost was too much. The one time payment for Voiceink was perfect. Very Affordable"],
    rating: 5
  },
  {
    id: 12,
    name: "Bryce Johnson",
    content: "Voiceink has grown so much just in the few months that I've had it. Awesome support and development team. I use it every day. My best purchase so far in 2025",
    image: "/testimonials/Bryce.png",
    highlights: ["My best purchase so far in 2025"],
    rating: 5
  },
  {
    id: 1,
    name: "JoseIndie",
    content: "I'm amazed by how seamlessly it transcribes with near 100% accuracy—especially thanks to local wispr AI for total privacy.",
    image: "https://yt3.ggpht.com/ytc/AIdro_mGGhXHzQ5kg3cgWQ0wHrN19u3c_-i6x6ZUsrnshgayEQpQ=s88-c-k-c0x00ffffff-no-rj",
    highlights: ["it transcribes with near 100% accuracy"],
    rating: 5
  },
  {
    id: 8,
    name: "Nigel Thompson",
    content: "This app is so good I have been using wispr flow at $12 a month..this app does the same things. It's basically a one off payment such a bargain! 👍",
    image: "https://pbs.twimg.com/profile_banners/176277412/1693251251/1500x500",
    highlights: ["This app is so good"],
    rating: 5
  },
  {
    id: 2,
    name: "Artawower LH",
    image: "https://lh3.googleusercontent.com/a-/ALV-UjUaEPzphF3AGS-SgxyaKTPdO3oPuqXxrOdjvKwOobFIeyAqIn-r=s128-p",
    content: "I use it almost every day, switched from wispr flow and I really like it.",
    highlights: ["switched from wispr flow and I really like it"],
    rating: 5
  },
  {
    id: 3,
    name: "Stealz Nozzles",
    content: "I just wanted to say VoiceInk is AWESOME! It's fast, accurate, and a joy to use (and most importantly, secure). Easiest purchase I've made in a long time.",
    highlights: ["Easiest purchase I've made in a long time"],
    rating: 5
  },
  {
    id: 4,
    name: "Michael",
    content: "Thanks for the quick reply, really appreciated and it exceeded my expectations. I gave VoiceInk already a try - awesome product.",
    highlights: ["it exceeded my expectations"],
    rating: 5
  },
  {
    id: 5,
    name: "Jeff Greeberg",
    image: "https://lh3.googleusercontent.com/a-/ALV-UjXbL6DfTPZXuCjkBUaxnKaHCr4EGDvkr8PWPBr_uCk6baLTWcY=s160-p-k-rw-no",
    content: "It's a really impressive app, especially when compared to the other paid tools.",
    highlights: ["It's a really impressive app"],
    rating: 5
  },
  {
    id: 6,
    name: "Darkawower",
    content: "It's really cool. I have been texting from your app and I like the large model and it is almost the same as Wispr Flow.",
    highlights: ["it is almost the same as Wispr Flow"],
    rating: 5
  },
  {
    id: 7,
    name: "Gus Silber",
    image: "https://lh3.googleusercontent.com/a-/ALV-UjVpIp7hfcofEZamjcHX0otFB_k3c-K0yXKd8z4eWWxOZ966rydikCV7rg=s128-p",
    content: "I have just upgraded to the Pro version of VoiceInk and am finding it a very useful. I have tried several AI speech-to-text apps, and VoiceInk is now my favourite at the moment.",
    highlights: ["VoiceInk is now my favourite at the moment"],
    rating: 5
  },
  {
    id: 9,
    name: "Robert Masata",
    content: "I have been using MacWhisper for the last months and have dreamed about virtually all the functions you have built in VoiceInk. You have been reading my mind I guess! Nice nice! Have bought the license after 7 Minutes, not 7 days!🔥",
    image: "/testimonials/Robert.jpg",
    highlights: ["bought the license after 7 Minutes, not 7 days!🔥"],
    rating: 5
  },
  {
    id: 10,
    name: "Frantz",
    content: "I subscribed to Wispr Flow before VoiceInk. Wispr Flow is faster, and they are working on a mobile app. Other than that, VoiceInk is more feature-rich and works just as well. So $12/month paid annually or $15/month paid monthly for Wispr Flow vs $25 for VoiceInk... It's an easy decision. I seriously think @Pax should be increasing his price. 🙂",
    highlights: ["I seriously think @Pax should be increasing his price. 🙂"],
    rating: 5
  },
  {
    id: 11,
    name: "Mark Belch",
    content: "Saves me a lot of thinking time and typing time. It works well and is fantastic value for money.",
    highlights: ["fantastic value for money"],
    rating: 5
  },
  {
    id: 16,
    name: "Michael Sayman",
    content: "VoiceInk > superwhipser. Free, open-sourced (so you can customize it however you'd like), and tons more features than superwhisper. can't go back to superwhisper after giving it a try",
    image: "/testimonials/michael-sayman.jpg",
    highlights: ["VoiceInk > superwhipser", "can't go back to superwhisper after giving it a try"],
    rating: 5
  },
  {
    id: 17,
    name: "アキ",
    content: "音声入力はMAcだとVoiceInkがよさげ。25ドル買い切りでこの性能？！ってくらい高性能で、コスパ最高。でもなぜかあまりバズっていないのが謎。",
    image: "/testimonials/aki.png",
    highlights: ["25ドル買い切りでこの性能？！ってくらい高性能で、コスパ最高"],
    rating: 5
  },
  {
    id: 18,
    name: "Roy Bao",
    content: "In pursue to be more productive I decide to start using a dictation app on my Mac. I tried @tryvoiceink, @superwhisperapp and also researched @WisprFlow. I decided to buy voiceink.",
    image: "/testimonials/roy-bao.jpg",
    highlights: ["I tried @tryvoiceink, @superwhisperapp and also researched @WisprFlow."],
    rating: 5
  },
  {
    id: 19,
    name: "Yann",
    content: "installed VoiceInk today and it has an AI enhance feature. Not rly needed when talking to Cursor but for everything else comes in very clutch. Also its just 25$ one time and has everything you need (model runs locally)",
    image: "/testimonials/yann.jpg",
    highlights: ["its just 25$ one time and has everything you need"],
    rating: 5
  },
  {
    id: 20,
    name: "Zach Silveira",
    content: "Have you tried @tryvoiceink it's so good and keeps your voice data fully local. I've compared both and it's just as solid if you run whisper large and have Gemma 4b do cleanup",
    image: "/testimonials/zach-silveira.jpg",
    highlights: ["it's so good and keeps your voice data fully local"],
    rating: 5
  },
  {
    id: 21,
    name: "Ian Harmon",
    content: "I recently installed @tryvoiceink for my vibe coding projects and general dictation and wow i'm impressed so far. It's looking like it could replace wispr flow for me. One off payment too. Great job @JoshiPax 🙌",
    image: "/testimonials/ian-harmon.jpg",
    highlights: ["wow i'm impressed so far", "It's looking like it could replace wispr flow for me"],
    rating: 5
  },
  {
    id: 22,
    name: "Vincent Ethier",
    content: "I just installed @tryvoiceink to replace the ahem flawed native dictation on MacOS. This is sooo good, so superior to MacWhisper and other alternatives out there. One-time fee after 7-day trial is good CX. Genuinely baffled that it hasn't gotten more traction, yet. @JoshiPax",
    image: "/testimonials/vincent-ethier.jpg",
    highlights: ["This is sooo good, so superior to MacWhisper and other alternatives out there"],
    rating: 5
  },
  {
    id: 23,
    name: "Johnathan Law",
    content: "Decided to just buy @tryvoiceink after playing with it briefly. Very impressive app @JoshiPax 🙌",
    image: "/testimonials/johnathan-law.jpg",
    highlights: ["Decided to just buy @tryvoiceink", "Very impressive app"],
    rating: 5
  },
  {
    id: 33,
    name: "Trist",
    content: "Dictating to AI is so wanky but so good. Just giga dump your brain rot and get something coherent and structured back. @tryvoiceink might be the highest ROI tool on the market right now",
    image: "https://i.imgur.com/vjx3bgt.png",
    profileUrl: "https://twitter.com/trist_adlington",
    highlights: ["highest ROI tool on the market right now", "get something coherent and structured back"],
    rating: 5
  },
  {
    id: 34,
    name: "Robert Talbert",
    content: "VoiceInk @tryvoiceink has been the MVP of my sabbatical so far. It's saved me hours of time, solved issues with repetitive stress on my wrists from typing so much, and made my writing freer and more conversational -- because I am just talking into my Mac.",
    image: "https://i.imgur.com/0Hi1xHF.png",
    profileUrl: "https://twitter.com/RobertTalbert",
    highlights: ["saved me hours of time", "made my writing freer and more conversational"],
    rating: 5
  },
  {
    id: 35,
    name: "DanielTsk",
    content: "been using @tryvoiceink, it's so good. the option to use local downloaded models at no cost, yet similar performance is insane. went from wisperflow $15/mo > superwhisper $8.49/mo > voiceink ($25 one time )",
    image: "https://i.imgur.com/ARM6beS.png",
    highlights: ["went from wisperflow $15/mo > superwhisper $8.49/mo > voiceink ($25 one time )", "similar performance is insane"],
    rating: 5
  },
  {
    id: 36,
    name: "Ben Holmes",
    content: "Y'all need to use @tryvoiceink for voice dictation. it's fast, 100% local, open source, compilable from the GitHub repo, and no subscription fee. Replaced Wisprflow with it and it's just as fast and accurate.",
    image: "https://i.imgur.com/9kr4qMB.png",
    profileUrl: "https://twitter.com/BHolmesDev",
    highlights: ["100% local, open source", "just as fast and accurate"],
    rating: 5
  },
  {
    id: 37,
    name: "Clayton Farr",
    content: "I've blathered to many a transcription tool and @tryvoiceink is seriously top-tippty-notch. Stellar work @JoshiPax",
    image: "https://i.imgur.com/KXKgk9A.png",
    profileUrl: "https://twitter.com/claytonfarr",
    highlights: ["seriously top-tippty-notch"],
    rating: 5
  },
  {
    id: 38,
    name: "Melvyn · Builder",
    content: "it's insane to think that some people pay 144$ / year for a tools that you can have for 29$ LIFETIME ! VoiceInk VS Superwhisper VS Flow",
    image: "https://i.imgur.com/5CBR4si.png",
    profileUrl: "https://twitter.com/melvynxdev",
    highlights: ["pay 144$ / year for a tools that you can have for 29$ LIFETIME !"],
    rating: 5
  }
]; 
